"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("common").controller("SelectVehicleController", function ($scope, VehiclesService, ModalService) {
  var _this = this;

  $scope.refresh = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(vehicle) {
      var values;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return VehiclesService.remoteSelectArray();

            case 2:
              values = _context.sent;


              if (values) {
                $scope.to.options = values;
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  $scope.create = function () {
    console.log();
    ModalService.open("vehicles/vehicle", {}).then(function (vehicle) {
      $scope.refresh(vehicle);
    });
  };

  $scope.reset = function () {
    console.log("reset");

    $scope.model[$scope.options.key] = null;
    $scope.optionName = "";
    $scope.$applyAsync();

    if ($scope.options.templateOptions.refresh) {
      $scope.options.templateOptions.refresh();
    }
  };

  $scope.edit = function () {
    ModalService.open("vehicles/vehicle", {
      _id: $scope.model[$scope.options.key].substring(1)
    }).then(function (_id) {
      $scope.refresh(_id);
    });
  };
});